<div class="col-md-12 m-b30">
  <div [hidden]="tipoData!='mostrar'">
    <dx-tab-panel
            #tabPanel
            [dataSource]="tabs"
            [selectedIndex]="0"
            [loop]="false"
            [animationEnabled]="true"
            [swipeEnabled]="false">
            <div *dxTemplate="let tab of 'title'">
              <span>{{tab.title}}</span>
            </div>
            <div *dxTemplate="let tab of 'item'">
              <dx-box *ngIf="tab.id==1"
                      direction="row">
                <dxi-item
                  [ratio]="1">
                  <dx-tabs
                    [dataSource]="menu1"
                    [width]="width1"
                    (onItemClick)="menu1Click($event)"
                    [scrollByContent]="true"
                    [showNavButtons]="true"
                    [selectedItemKeys]="menu1[0]"
                  ></dx-tabs>
                  <dx-box *ngIf="menu1Selected==0"
                          direction="row">
                    <dxi-item
                      [ratio]="1">
                      <dx-box
                        direction="row">
                        <dxi-item [ratio]="1">
                          <dx-radio-group
                            [items]="tipo"
                            [value]="tipoSelected"
                            (onValueChanged)="onValueChanged($event)"
                            layout="horizontal">
                          </dx-radio-group>
                        </dxi-item>
                      </dx-box>
                      <div *ngIf="tipoSelected=='Dólares'">
                        <highcharts-chart
                          *ngIf="chartOptions11!==undefined"
                          class="container4"
                          [Highcharts]="Highcharts"
                          [options]="chartOptions11" [ngStyle]="{'width':width}"
                          style="height: 700px;display:block;"></highcharts-chart>
                        <div *ngIf="chartOptions11!==undefined" class="table-responsive" style="position: relative; top:-100px;">
                          <table class="table">
                            <tr>
                              <th></th>
                              <th *ngFor="let gestion of chartOptions11.xAxis.categories">{{gestion}}</th>
                            </tr>
                            <tr *ngFor="let item of chartOptions11.series">
                              <td style="font-weight: bold">{{item.name}}</td>
                              <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                            </tr>
                          </table>
                          <p class="{{classLeyenda}}">{{leyenda}}</p>
                        </div>
                        <highcharts-chart
                          *ngIf="chartOptions10!=undefined"
                          [Highcharts]="Highcharts"
                          [options]="chartOptions10" [ngStyle]="{'width':width}"
                          style="height: 700px;display:block"></highcharts-chart>
                        <div *ngIf="chartOptions10!=undefined" class="table-responsive" style="position: relative; top:-150px;">
                          <table class="table">
                            <tr>
                              <th></th>
                              <th *ngFor="let gestion of chartOptions10.xAxis.categories">{{gestion}}</th>
                            </tr>
                            <tr *ngFor="let item of chartOptions10.series">
                              <td style="font-weight: bold">{{item.name}}</td>
                              <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                            </tr>
                          </table>
                          <p class="{{classLeyenda}}">{{leyenda}}</p>
                          <p class="{{classLeyenda}}">(**) El sector energía fue clasificado en el grupo sectorial de infraestructura y a partir de la gestión 2015 en productivo</p>
                        </div>
                        <highcharts-chart
                          *ngIf="chartOptions12!=undefined"
                          class="container3"
                          [Highcharts]="Highcharts"
                          [options]="chartOptions12" [ngStyle]="{'width':width}"
                          style="height: 500px;display:block"></highcharts-chart>
                        <div *ngIf="chartOptions12!=undefined" class="table-responsive" style="position: relative; top:-150px;">
                          <table class="table">
                            <tr>
                              <th></th>
                              <th *ngFor="let gestion of chartOptions12.xAxis.categories">{{gestion}}</th>
                            </tr>
                            <tr *ngFor="let item of chartOptions12.series">
                              <td style="font-weight: bold">{{item.name}}</td>
                              <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                            </tr>
                          </table>
                          <p class="{{classLeyenda}}">{{leyenda}}</p>
                        </div>
                      </div>
                      <div *ngIf="tipoSelected=='Bolivianos'">
                        <highcharts-chart
                          class="container4"
                          *ngIf="chartOptions2!==undefined"
                          [Highcharts]="Highcharts"
                          [options]="chartOptions2" [ngStyle]="{'width':width}"
                          style="height: 700px;display:block"></highcharts-chart>
                        <div *ngIf="chartOptions2!==undefined" class="table-responsive" [ngStyle]="{'width':widthTable}" style="position: relative; top:-100px;">
                          <table class="table">
                            <tr>
                              <th></th>
                              <th *ngFor="let gestion of chartOptions2.xAxis.categories">{{gestion}}</th>
                            </tr>
                            <tr *ngFor="let item of chartOptions2.series">
                              <td style="font-weight: bold">{{item.name}}</td>
                              <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                            </tr>
                          </table>
                          <p class="{{classLeyenda}}">{{leyenda}}</p>
                        </div>
                        <highcharts-chart
                          *ngIf="chartOptions!=undefined"
                          [Highcharts]="Highcharts"
                          [options]="chartOptions" [ngStyle]="{'width':width}"
                          style="height: 700px;display:block"></highcharts-chart>
                        <div *ngIf="chartOptions!=undefined" class="table-responsive" [ngStyle]="{'width':widthTable}" style="position: relative; top:-150px;">
                          <table class="table">
                            <tr>
                              <th></th>
                              <th *ngFor="let gestion of chartOptions.xAxis.categories">{{gestion}}</th>
                            </tr>
                            <tr *ngFor="let item of chartOptions.series">
                              <td style="font-weight: bold">{{item.name}}</td>
                              <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                            </tr>
                          </table>
                          <p class="{{classLeyenda}}">{{leyenda}}</p>
                          <p class="{{classLeyenda}}">(**) El sector energía fue clasificado en el grupo sectorial de infraestructura y a partir de la gestión 2015 en productivo</p>
                        </div>
                        <highcharts-chart
                          *ngIf="chartOptions3!=undefined"
                          class="container3"
                          [Highcharts]="Highcharts"
                          [options]="chartOptions3" [ngStyle]="{'width':width}"
                          style="height: 500px;display:block"></highcharts-chart>
                        <div *ngIf="chartOptions3!=undefined" class="table-responsive" [ngStyle]="{'width':widthTable}" style="position: relative; top:-150px;">
                          <table class="table">
                            <tr>
                              <th></th>
                              <th *ngFor="let gestion of chartOptions3.xAxis.categories">{{gestion}}</th>
                            </tr>
                            <tr *ngFor="let item of chartOptions3.series">
                              <td style="font-weight: bold">{{item.name}}</td>
                              <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                            </tr>
                          </table>
                          <p class="{{classLeyenda}}">{{leyenda}}</p>
                        </div>
                      </div>
                    </dxi-item>
                  </dx-box>
                  <dx-box *ngIf="menu1Selected==1"
                          direction="row">
                    <dxi-item [ratio]="1" *ngIf="chartOptions20!==undefined">
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="chartOptions20" [ngStyle]="{'width':width}"
                        style="height: 600px;display:block"></highcharts-chart>
                      <div class="table-responsive" [ngStyle]="{'width':widthTable}" style="position: relative; top:-150px;">
                        <table class="table">
                          <tr>
                            <th></th>
                            <th *ngFor="let gestion of chartOptions20.xAxis.categories">{{gestion}}</th>
                          </tr>
                          <tr *ngFor="let item of chartOptions20.series">
                            <td style="font-weight: bold">{{item.name}}</td>
                            <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                          </tr>
                        </table>
                        <p class="{{classLeyenda}}">{{leyenda}}</p>
                      </div>

                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="chartOptions7" [ngStyle]="{'width':width}"
                        style="height: 600px;display:block"></highcharts-chart>
                      <div class="table-responsive" [ngStyle]="{'width':widthTable}" style="position: relative; top:-150px;">
                        <table class="table">
                          <tr>
                            <th></th>
                            <th *ngFor="let gestion of chartOptions7.xAxis.categories">{{gestion}}</th>
                          </tr>
                          <tr *ngFor="let item of chartOptions7.series">
                            <td style="font-weight: bold">{{item.name}}</td>
                            <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                          </tr>
                        </table>
                        <p class="{{classLeyenda}}">{{leyenda}}</p>
                      </div>
                    </dxi-item>
                  </dx-box>
                  <dx-box *ngIf="menu1Selected==2"
                          direction="row">
                    <dxi-item [ratio]="1" *ngIf="chartOptions15!=undefined && chartOptions8!=undefined && chartOptions16!=undefined">
                      <highcharts-chart
                        *ngIf="false"
                        [Highcharts]="Highcharts"
                        [options]="chartOptions15" [ngStyle]="{'width':width}"
                        style="height: 600px;display:block"
                      ></highcharts-chart>
                      <p *ngIf="false" class="{{classLeyenda}}">{{leyenda}}</p>
                      <br>
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="chartOptions8" [ngStyle]="{'width':width}"
                        style="height: 600px;display:block"
                      ></highcharts-chart>
                      <p class="{{classLeyenda}}">{{leyenda}}</p>
                      <br>
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="chartOptions16" [ngStyle]="{'width':width}"
                        style="height: 600px;display:block"
                      ></highcharts-chart>
                      <p class="{{classLeyenda}}">{{leyenda}}</p>
                    </dxi-item>
                  </dx-box>
                  <dx-box *ngIf="menu1Selected==3"
                          direction="row">
                    <dxi-item [ratio]="1">
                      <dx-box
                        direction="row">
                        <dxi-item [ratio]="1" style="text-align: center">
                          <dx-radio-group
                            [items]="departamentos"
                            [(value)]="departamento"
                            valueExpr="id"
                            displayExpr="departamento"
                            (onValueChanged)="onDepartamentoChanged($event)"
                            layout="horizontal">
                          </dx-radio-group>
                        </dxi-item>
                      </dx-box>
                      <div>
                        <highcharts-chart
                          *ngIf="dep1!=undefined"
                          [Highcharts]="Highcharts"
                          [options]="dep1" [ngStyle]="{'width':width}"
                          style="height: 700px;display:block"></highcharts-chart>
                        <div  *ngIf="dep1!=undefined" class="table-responsive" [ngStyle]="{'width':widthTable}" style="position: relative; top:-150px;">
                          <table class="table">
                            <tr>
                              <th></th>
                              <th *ngFor="let gestion of dep1.xAxis.categories">{{gestion}}</th>
                            </tr>
                            <tr *ngFor="let item of dep1.series">
                              <td style="font-weight: bold">{{item.name}}</td>
                              <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                            </tr>
                          </table>
                          <p class="{{classLeyenda}}">{{leyenda}}</p>
                        </div>
                      </div>
                    </dxi-item>
                  </dx-box>
                  <dx-box *ngIf="menu1Selected==4 && false"
                          direction="row" >
                    <dxi-item
                      [ratio]="1" *ngIf="chartOptions19!==undefined">
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="chartOptions19" [ngStyle]="{'width':width}"
                        style="height: 400px;display:block"
                      ></highcharts-chart>
                      <div *ngIf="chartOptions19!==undefined" class="table-responsive" [ngStyle]="{'width':widthTable}" style="position: relative; top:0px;">
                        <table class="table">
                          <tr>
                            <th></th>
                            <th *ngFor="let gestion of chartOptions19.xAxis.categories" [innerHTML]="gestion"></th>
                          </tr>
                          <tr *ngFor="let item of chartOptions19.series">
                            <td style="font-weight: bold">{{item.name}}</td>
                            <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                          </tr>
                        </table>
                        <p class="{{classLeyenda}}">{{leyenda}}</p>
                      </div>
                        <highcharts-chart
                          [Highcharts]="Highcharts"
                          [options]="chartOptions14" [ngStyle]="{'width':width}"
                          style="height: 400px;display:block"
                        ></highcharts-chart>
                        <div *ngIf="chartOptions14!==undefined" class="table-responsive" [ngStyle]="{'width':widthTable}" style="position: relative; top:0px;">
                          <table class="table">
                            <tr>
                              <th></th>
                              <th *ngFor="let gestion of chartOptions14.xAxis.categories" [innerHTML]="gestion"></th>
                            </tr>
                            <tr *ngFor="let item of chartOptions14.series">
                              <td style="font-weight: bold">{{item.name}}</td>
                              <td *ngFor="let d of item.data" >{{d.y|number}}</td>
                            </tr>
                          </table>
                          <p class="{{classLeyenda}}">{{leyenda}}</p>
                        </div>
                    </dxi-item>
                  </dx-box>
                </dxi-item>
              </dx-box>
              <dx-box *ngIf="tab.id==2"
                      direction="row"
                      width="100%">
                <dxi-item [ratio]="1.1">
                  <div class="row">

                    <div class="col-md-12">
                      <div>
                        <dx-tabs
                          [dataSource]="menu2"
                          [width]="width1"
                          (onItemClick)="menu2Click($event)"
                          [scrollByContent]="true"
                          [showNavButtons]="true"
                          [selectedItemKeys]="menu2[0]"
                        ></dx-tabs>
                      </div>
                      <dx-box *ngIf="menu2Selected==3"
                              direction="row">
                        <dxi-item
                          [ratio]="1">
                          <div style="font-size: 20px;" [innerHTML]="title"></div>
                          <div style="font-size: 12px;">{{subTitle}}</div>
                          <dx-tree-list
                            id="tasks"
                            [dataSource]="content"
                            [width]="width"
                            keyExpr="id"
                            parentIdExpr="parent"
                            [columnAutoWidth]="true"
                            [hoverStateEnabled]="true"
                            [wordWrapEnabled]="true"
                            [rowAlternationEnabled]="true"
                            [expandedRowKeys]="expanded"
                            [showBorders]="true">
                            <dxo-scrolling mode="standard"></dxo-scrolling>
                            <dxo-filter-row [visible]="true"></dxo-filter-row>
                            <dxo-paging
                              [enabled]="true"
                              [pageSize]="10">
                            </dxo-paging>
                            <dxo-pager
                              [showPageSizeSelector]="true"
                              [allowedPageSizes]="[5, 10, 20]"
                              [showInfo]="true">
                            </dxo-pager>
                            <dxo-search-panel [visible]="true" placeholder="Buscar" width="250"></dxo-search-panel>
                            <dxo-selection mode="simple"></dxo-selection>
                            <dxi-column dataField="institucion" caption="Entidad"></dxi-column>
                            <dxi-column dataField="pge" caption="Presupuesto Aprobado" [width]="130">
                              <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                            </dxi-column>
                            <dxi-column dataField="ejecucionFinanciera" caption="Ejecución Financiera" dataType="number" [width]="130">
                              <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                            </dxi-column>
                            <dxi-column dataField="porcentajeEjecFinPge" caption="% Ejec. Fin. / Presup." dataType="number" alignment="right" [width]="140">
                              <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                            </dxi-column>
                            <dxi-column dataField="porcentajePartEjec" caption="% Part. Ejec." dataType="number" alignment="right" [width]="120">
                              <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                            </dxi-column>
                            <!--<dxi-column [width]="70" caption="Detalle" [allowFiltering]="false" visible="false"
                                        [allowSorting]="false" cellTemplate="accionTemplate"></dxi-column>
                            <div *dxTemplate="let data of 'accionTemplate'">
                              <dx-button *ngIf="data.data.url"  stylingMode="text" icon="assets/images/pdf.svg" (onClick)="openDoc(data.data.url)" hint="Ver documento"></dx-button>
                            </div>-->

                          </dx-tree-list>
                          <p class="text-center">
                            {{leyenda}} <br>
                          </p>
                        </dxi-item>
                      </dx-box>
                      <dx-box *ngIf="menu2Selected==1" direction="row">
                        <dxi-item
                          [ratio]="1" *ngIf="chartOptions17!=undefined">
                          <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="chartOptions5" [ngStyle]="{'width':width}"
                            style="height: 400px;display:block;margin-bottom: 70px;"
                          ></highcharts-chart>
                          <highcharts-chart
                            *ngIf="false"
                            [Highcharts]="Highcharts"
                            [options]="chartOptions17" [ngStyle]="{'width':width}"
                            style="height: 400px;display:block;margin-bottom: 70px;"
                          ></highcharts-chart>
                        </dxi-item>
                      </dx-box>
                      <dx-box *ngIf="menu2Selected==0" direction="row">
                        <dxi-item
                          [ratio]="1" *ngIf="chartOptions18!=undefined">
                          <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="chartOptions4" [ngStyle]="{'width':width}"
                            style="height: 400px;display:block;margin-bottom: 70px;"
                          ></highcharts-chart>
                          <highcharts-chart
                            *ngIf="false"
                            [Highcharts]="Highcharts"
                            [options]="chartOptions18" [ngStyle]="{'width':width}"
                            style="height: 400px;display:block;margin-bottom: 70px;"
                          ></highcharts-chart>
                        </dxi-item>
                      </dx-box>
                      <dx-box *ngIf="menu2Selected==4"
                              direction="row" >
                        <dxi-item
                          [ratio]="1" *ngIf="chartOptions13!=undefined">
                          <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="chartOptions13" [ngStyle]="{'width':width}"
                            style="height: 400px;display:block"
                          ></highcharts-chart>
                        </dxi-item>
                      </dx-box>
                      <dx-box *ngIf="menu2Selected==2"
                              direction="row">
                        <dxi-item
                          [ratio]="1"
                          style="text-align: center; margin: auto; height: 600px">
                          <div>
                            <iframe style="margin: auto" #iframe style="border:none; width: 400px; height: 500px;" scrolling="no" src="assets/map.html?data=1003"></iframe>
                          </div>

                        </dxi-item>
                      </dx-box>
                    </div>
                  </div>
                </dxi-item>
              </dx-box>
            </div>
    </dx-tab-panel>
  </div>

</div>
<dx-popup
  class="popup"
  minWidth="400px"
  fullScreen="true"
  [showTitle]="false"
  title="Evolución de la Ejecución"
  [dragEnabled]="false"
  [closeOnOutsideClick]="true"
  [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <div style="text-align: right;">
      <div style="float:left; font-size: 18px;font-weight: bold;line-height: 2;">
        Evolución de la Ejecución
      </div>
      <dx-button
        id="button"
        icon="close"
        (onClick)="popupVisible=false;">
      </dx-button>
    </div>
    <embed
      [src]="pdfSrc"
      style="width: 100%;height: 100%"
      type="application/pdf">
  </div>
</dx-popup>
<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.4)"
  message="Cargando..."
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>





// WEBPACK FOOTER //
// ./src/app/pages/report/charts/charts.component.html